import { jsx } from "react/jsx-runtime";
import { StyledBackdrop } from "./styles.js";
const SpinnerOverlay = ({ hasBackdrop, children }) => {
  return /* @__PURE__ */ jsx(
    StyledBackdrop,
    {
      "aria-hidden": void 0,
      open: true,
      isFullscreen: hasBackdrop,
      children
    }
  );
};
export {
  SpinnerOverlay
};
